var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11C3.5 6.58172 7.08172 3 11.5 3H50.5C54.9183 3 58.5 6.58172 58.5 11V50C58.5 54.4183 54.9183 58 50.5 58H11.5C7.08172 58 3.5 54.4183 3.5 50V11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5097 45.3026L30.0369 46.0452L29.5097 45.3026L27.4174 46.7881C26.496 47.4422 25.1975 46.9798 24.8993 45.8506L24.239 43.3502C23.8655 41.9356 22.654 40.8986 21.1969 40.77L18.6517 40.5455C17.5314 40.4467 16.818 39.2358 17.3098 38.1684L18.3905 35.8231C19.002 34.496 18.7299 32.9219 17.7031 31.8825L15.8958 30.0531C15.0805 29.2278 15.3308 27.8353 16.3621 27.3486L18.678 26.2557C19.9998 25.632 20.7862 24.2427 20.6598 22.7861L20.4361 20.2078C20.3342 19.0338 21.409 18.1508 22.4903 18.4448L24.9578 19.1157C26.3704 19.4997 27.864 18.9452 28.6959 17.7405L30.1605 15.6197C30.8133 14.6744 32.1867 14.6744 32.8395 15.6197L34.3041 17.7405C35.136 18.9452 36.6296 19.4997 38.0422 19.1157L40.5097 18.4448C41.591 18.1508 42.6658 19.0338 42.5639 20.2078L42.3402 22.7861C42.2138 24.2427 43.0002 25.632 44.322 26.2557L46.6379 27.3486C47.6692 27.8353 47.9195 29.2278 47.1042 30.0531L45.2969 31.8825C44.2701 32.9219 43.998 34.496 44.6095 35.8231L45.6902 38.1684C46.182 39.2358 45.4686 40.4467 44.3483 40.5455L41.8031 40.77C40.346 40.8986 39.1345 41.9356 38.761 43.3502L38.1007 45.8506C37.8025 46.9798 36.504 47.4422 35.5826 46.7881L33.4903 45.3026C32.2963 44.4549 30.7037 44.4549 29.5097 45.3026Z",
    fill: "#3B968B",
    fillOpacity: 0.5,
    stroke: "#3B968B",
    strokeWidth: 1.82143
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4141 28.4706C38.9111 27.9385 38.9111 27.0758 38.4141 26.5436C37.9171 26.0115 37.1113 26.0115 36.6143 26.5436L29.9958 33.7863L27.6022 31.2236C27.1052 30.6914 26.2994 30.6914 25.8024 31.2236C25.3054 31.7557 25.3054 32.6185 25.8024 33.1506L29.0932 36.674C29.3424 36.9408 29.6691 37.0738 29.9957 37.0731C30.3223 37.0739 30.6492 36.9408 30.8984 36.674L38.4141 28.4706Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4H50.5V2H11.5V4ZM57.5 11V50H59.5V11H57.5ZM50.5 57H11.5V59H50.5V57ZM4.5 50V11H2.5V50H4.5ZM11.5 57C7.63401 57 4.5 53.866 4.5 50H2.5C2.5 54.9706 6.52944 59 11.5 59V57ZM57.5 50C57.5 53.866 54.366 57 50.5 57V59C55.4706 59 59.5 54.9706 59.5 50H57.5ZM50.5 4C54.366 4 57.5 7.13401 57.5 11H59.5C59.5 6.02944 55.4706 2 50.5 2V4ZM11.5 2C6.52944 2 2.5 6.02944 2.5 11H4.5C4.5 7.13401 7.63401 4 11.5 4V2Z",
    fill: "#2E2D29",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.5,
    y: 0,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3571,
    height: 10.9286,
    fill: "white",
    transform: "translate(25.4297 26.1445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.3af81bced6b3b803f63510158a44d335.svg";
export { ForwardRef as ReactComponent };